import AccountCard from 'components/tools/AccountCard';
import Callout from 'components/tools/Callout';
import ConfirmationModal from 'components/layout/ConfirmationModal';
import Customer from 'models/customer';
import CustomerApi from 'api/customer';
import DealerApi from 'api/dealer';
import IntlWrapper from 'components/layout/intlWrapper';
import path from 'path';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import ValidationGroup from 'helpers/validation';
import {Button, Header} from 'components/layout';
import {events, router} from 'lib';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {Loader, Row, Col} from 'components';
import {mergeCustomers, ignoreMerge} from 'api/dataCleanup';

// Let you deep link to a customer merge so can link from outside the tool
let render = (container, params) => {
  console.info('[UI.page.tools.accounts.find-replace] rendering page');
  ReactDOM.render(
    <IntlWrapper>
      <WrapperMerge id1={parseInt(params.id1)} id2={parseInt(params.id2)}
                    fallbackAccountID={params.fallbackAccountID === 'true'}
                    cancel={() => location.hash = path.join('customer', params.id1)}
                    mergeComplete={id => location.hash = path.join('customer', id.toString())}/>
    </IntlWrapper>, container);
  events.publish('page-change', {page: 'tools'});
};

console.info('[UI.page.customer] register route');
router.rr.add([{
  path: 'tools/accounts/merge-customer/:id1/:id2/:fallbackAccountID',
  handler: routeUtils.requireAuth(render),
}]);

class Merge extends Component {
  constructor(props) {
    super(props);

    let newCustomer = new Customer({});

    this.state = {
      confirmVisible: false,
      loaded: false,
      customer1: null,
      customer2: null,
      newCustomer,
      dealer: {},
      select: {
        accountNum: undefined,
        address1: undefined,
        posID: undefined,
      },
    };

    this.group = new ValidationGroup(this._save);
  }

  componentWillMount() {
    Promise.all([
      CustomerApi.getCustomer(this.props.id1),
      CustomerApi.getCustomer(this.props.id2),
      CustomerApi.getCustomerRecentInvoiceHistory(this.props.id1),
      CustomerApi.getCustomerRecentInvoiceHistory(this.props.id2),
      DealerApi.getDealer(session.getUser().dealerId)])
      .then(([customer1, customer2, customerInvoice1, customerInvoice2, dealer]) => {
        let newCustomer = customer1.clone();

        newCustomer.pools = (customer1.pools || []).concat(customer2.pools || []);
        newCustomer.dirtied = {
          accountNum: 0,
          address: 0,
          POSVendorID: 0,
        };

        customer1.purchaseData = customerInvoice1;
        customer2.purchaseData = customerInvoice2;

        newCustomer.purchaseData = {
          LastPurchaseAmount: customer1.purchaseData.LastPurchaseDate > customer2.purchaseData.LastPurchaseDate ?
            customer1.purchaseData.LastPurchaseAmount :
            customer2.purchaseData.LastPurchaseAmount,
          LastPurchaseDate: customer1.purchaseData.LastPurchaseDate > customer2.purchaseData.LastPurchaseDate ?
            customer1.purchaseData.LastPurchaseDate :
            customer2.purchaseData.LastPurchaseDate,
          YearToDatePurchaseAmount: customer1.purchaseData.YearToDatePurchaseAmount + customer2.purchaseData.YearToDatePurchaseAmount,
        };
        newCustomer.POSTotalSales = customer1.POSTotalSales + customer2.POSTotalSales;

        this.setState({
          customer1,
          customer2,
          dealer,
          newCustomer,
          loaded: true,
          select: {
            accountNum: 'customer1',
            address: 'customer1',
            posID: 'customer1',
          },
        });
      });
  }

  onDirty = field => {
    let select = this.state.select;

    select[field] = undefined;
    this.setState({select});
  };

  _save = () => {
    let cust = this.newAccountCard.getWrappedInstance().getCustomer();

    if (!cust || cust.customerContacts.length === 0) {
      events.publish('error.user', {message: this.props.intl.formatMessage({id: 'tools.merge.account.contact'})});
      return;
    }
    this.setState({
      confirmVisible: true,
      toSave: cust,
    });
  };

  addContact = (from, contact) => {
    let newCustomer = this.state.newCustomer;

    newCustomer.customerContacts = newCustomer.customerContacts || [];
    newCustomer.customerContacts.push(contact);
    newCustomer.customerContacts = newCustomer.customerContacts.reduce((acc, x) => { // Deduplicate contacts
      if (!acc.find(y => y.id === x.id)) {
        acc.push(x);
      }
      return acc;
    }, []);
    this.setState({
      newCustomer,
    });
  };

  cancel = () => {
    const {cancel, fallbackAccountID} = this.props;

    if (fallbackAccountID !== undefined) {
      window.location.hash = `customer/${fallbackAccountID}`;
    } else {
      cancel();
    }
  };

  closeConfirm = () => {
    this.setState({
      confirmVisible: false,
      toSave: undefined,
    });
  };

  ignore = () => {
    ignoreMerge(this.props.id1, this.props.id2)
      .then(res => {
        if (!res.success) {
          throw new Error('Could not ignore merge successfully');
        }

        this.props.reloadReport();
      })
      .catch(err => {
        console.error(err);
        events.publish('error.user', {message: this.props.intl.formatMessage({id: 'tools.merge.incompleted.request'})});
      });
  };

  removeContact = (from, contact) => {
    let newCustomer = this.state.newCustomer;

    newCustomer.customerContacts = (newCustomer.customerContacts || []).filter(x => x.id !== contact.id);
    this.setState({newCustomer});
  };

  select = (from, field) => {
    let newCustomer = this.state.newCustomer;

    if (field === 'posID') {
      newCustomer.POSVendorID = this.state[from]['POSVendorID'];
    } else if (field !== 'address') {
      newCustomer[field] = this.state[from][field];
    } else {
      ['address1', 'address2', 'city', 'state', 'zip', 'addressCompleteID', 'country', 'addressVerified'].forEach(x => newCustomer[x] = this.state[from][x]);
    }

    let select = this.state.select;

    select[field] = from;

    newCustomer.dirtied[field] += 1;

    this.setState({
      newCustomer,
      select,
    });
  };

  submitConfirm = () => {
    this.setState({
      confirmVisible: false,
    });
    mergeCustomers(this.state.toSave.toApiFormat(), [this.state.customer1.toApiFormat(), this.state.customer2.toApiFormat()])
      .then(res => {
        if (!res.success) {
          throw new Error('Failed to merge customer.');
        } else {
          session.deleteCustomer(this.state.toSave);
          session.deleteCustomer(this.state.customer1);
          session.deleteCustomer(this.state.customer2);

          setTimeout(() => {
            events.publish('success.user', {
              message: <span><FormattedMessage id="tools.merge.merge.complete"/>&nbsp;
                <Callout href={'#customer/' + res.data.ID}>{this.state.toSave.customerContacts[0].nameFirst ?
                  this.state.toSave.customerContacts[0].name : this.state.toSave.customerContacts[0].organization}</Callout>,
                &nbsp;<FormattedMessage id="general.account.number"/>: <Callout
                  href={'#customer/' + res.data.ID}>{this.state.toSave.accountNum}</Callout>
              </span>,
            });
          }, 100);

          if (this.props.fallbackAccountID !== undefined) {
            window.location.hash = `customer/${res.data.ID}`;
          } else {
            this.props.mergeComplete(res.data.ID);
          }
        }
      })
      .catch(err => {
        console.error(err);
        events.publish('error.user', {message: this.props.intl.formatMessage({id: 'tools.merge.failed'})});
        this.closeConfirm();
      });
  };

  render() {
    let {formatMessage} = this.props.intl;

    return <div className='container'>
      {location.hash.includes('merge-customer') ? <Header mainTitle={formatMessage({id: 'general.accounts'})}
              subTitle={formatMessage({id: 'tools.merge.duplicate.accounts'})} mainTitleReturn='#tools/accounts'/> : null}
      <div style={{marginBottom: 100}}>
        <Loader loaded={this.state.loaded}>
          <ConfirmationModal dismissKey='MERGE_ACCOUNT_DISMISS'
                             message={formatMessage({id: 'tools.merge.confirm.merge'})}
                             submitLabel={formatMessage({id: 'general.confirm'})}
                             onClose={this.closeConfirm} onSubmit={this.submitConfirm}
                             visible={this.state.confirmVisible}/>

          <h3 className='blue' style={{marginBottom: 20}}><FormattedMessage id='tools.merge.select.fields'/></h3>
          <Row>
            <Col md={4}>
              <AccountCard title={formatMessage({id: 'general.account'}) + ' A'} customer={this.state.customer1}
                           selected={Object.keys(this.state.select).filter(x => this.state.select[x] === 'customer1')}
                           select={val => this.select('customer1', val)}
                           dealer={this.state.dealer}
                           addContact={contact => this.addContact('customer1', contact)}
                           removeContact={contact => this.removeContact('customer1', contact)}/>
            </Col>
            <Col md={4}>
              <AccountCard title={formatMessage({id: 'general.account'}) + ' B'} customer={this.state.customer2}
                           selected={Object.keys(this.state.select).filter(x => this.state.select[x] === 'customer2')}
                           select={val => this.select('customer2', val)}
                           dealer={this.state.dealer}
                           addContact={contact => this.addContact('customer2', contact)}
                           removeContact={contact => this.removeContact('customer2', contact)}/>
            </Col>
            <Col md={4}>
              <AccountCard active title={formatMessage({id: 'tools.merge.new.account'})}
                           customer={this.state.newCustomer} ref={n => this.newAccountCard = n} onDirty={this.onDirty}
                           group={this.group} dealer={this.state.dealer}/>
            </Col>
            <Col md={12} style={{marginTop: 20}}>
              {this.props.fallbackAccountID === undefined ?
                <Button default onClick={this.ignore}><FormattedMessage id="tools.merge.ignore"/></Button> :
                null
              }
              <div className='pull-right'>
                <Button default onClick={this.props.cancel} style={{marginRight: 20}}><FormattedMessage
                  id="general.cancel"/></Button>
                <Button primary onClick={this.group.validate}><FormattedMessage id="general.merge"/></Button>
              </div>
            </Col>
          </Row>
        </Loader>
      </div>
    </div>;
  }
}

Merge.propTypes = {
  cancel: PropTypes.func.isRequired,
  id1: PropTypes.number.isRequired,
  id2: PropTypes.number.isRequired,
  mergeComplete: PropTypes.func.isRequired,
  fallbackAccountID: PropTypes.string,
  reloadReport: PropTypes.func,
};

let WrapperMerge = injectIntl(Merge);

export default WrapperMerge;
